import React from 'react';
import Preview from '../index';
import { useSelector } from 'react-redux';
import {
  EnumPromotionCollapseId,
  getCollapseOpenId,
  getPopUpWindowDataById,
} from '../../redux';

export default (props: any) => {
  const openId = useSelector(getCollapseOpenId());

  const PopUpWindow = useSelector(getPopUpWindowDataById(openId));

  const getDisplayData = () => {
    return PopUpWindow;
  };

  const getDisplayType = ():
    | 'featureProduct'
    | 'EDM'
    | 'popUpImage'
    | 'popUpEDM' => {
    if (openId) {
      if (openId === EnumPromotionCollapseId.featuredProducts) {
        return 'featureProduct';
      } else {
        return 'popUpImage';
      }
    }
  };

  return (
    <Preview
      displayType={getDisplayType()}
      data={getDisplayData()}
      withoutCollapse={props.withoutCollapse}
    />
  );
};
